<template>
    <div class="min-h-screen bg-[#0E061C] flex items-center justify-center px-4">
      <div class="bg-[#1A1025] rounded-lg p-8 w-full max-w-md">
        <h2 class="text-white text-xl font-semibold mb-6">
          Login and Get Your Drops
        </h2>
        
        <form @submit.prevent="handleLogin" class="space-y-6">
          <!-- Email Input -->
          <div>
            <label class="block text-white mb-2">Email</label>
            <input 
              type="email" 
              v-model="email"
              class="w-full bg-[#2A2438] text-white rounded px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-600"
              required
            >
          </div>
  
          <!-- Password Input -->
          <div>
            <label class="block text-white mb-2">Password</label>
            <input 
              type="password" 
              v-model="password"
              class="w-full bg-[#2A2438] text-white rounded px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-600"
              required
            >
          </div>
  
          <!-- reCAPTCHA -->
          <div class="flex justify-center">
            <div class="g-recaptcha" data-sitekey="your-recaptcha-site-key"></div>
          </div>
  
          <!-- Login Button -->
          <button 
            type="submit"
            class="w-full bg-purple-600 text-white rounded py-3 font-medium hover:bg-purple-700 transition duration-300"
          >
            Log In
          </button>
  
          <!-- Sign Up Link -->
          <div class="text-center text-gray-400">
            New Here? 
            <router-link to="/register" class="text-purple-500 hover:text-purple-400">
              Sign Up
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  import { useRouter } from 'vue-router'
  import { onMounted } from 'vue'  // 添加这行导入语句
  
  const router = useRouter()
  const email = ref('')
  const password = ref('')

  const errorMessage = ref('')
  const isLoading = ref(false)
  
  // 添加 reCAPTCHA 脚本
  const addRecaptchaScript = () => {
    const script = document.createElement('script')
    //script.src = 'https://www.google.com/recaptcha/api.js'
    //script.async = true
    //script.defer = true
    document.head.appendChild(script)
  }
  
  // 在组件挂载时加载 reCAPTCHA
  onMounted(() => {
    addRecaptchaScript()
  })



  const handleLogin = async () => {
  try {
    errorMessage.value = ''
    if (!validateForm()) return

    isLoading.value = true
    
    // 这里模拟API调用
    // 实际使用时替换为真实的API调用
    const response = await fetch('your-api-endpoint/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: email.value,
        password: password.value,
      }),
    })

    if (!response.ok) {
      throw new Error('Login failed')
    }

    const data = await response.json()
    
    // 存储token（如果后端返回的话）
    localStorage.setItem('token', data.token)
    
    // 登录成功后跳转
    await router.push('/dashboard')
    
  } catch (error) {
    console.error('Login failed:', error)
    errorMessage.value = 'Invalid email or password'
  } finally {
    isLoading.value = false
  }
}

  const validateForm = () => {
  if (!email.value) {
    errorMessage.value = 'Please enter your email'
    return false
  }
  if (!password.value) {
    errorMessage.value = 'Please enter your password'
    return false
  }
  // 简单的邮箱格式验证
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(email.value)) {
    errorMessage.value = 'Please enter a valid email address'
    return false
  }
  return true
}
  </script>
  
  <style>
  /* 可以添加自定义样式 */
  </style>